import React from 'react'

const styles = {
    container: {
        display: 'flex',
        justifyContent: 'center',
        backgroundColor: '#EEE',
    },
    text: {
        margin: '0',
        color: '#444',
        fontSize: '12px',
        fontFamily: 'Montserrat',
    },
    link: {
        textDecoration: 'none',
        color: '#444',
        fontSize: '12px',
        fontFamily: 'Montserrat',
    }
}

export default function Info() {
    return (
        <div style={styles.container}>
            <p style={styles.text}>
                 <a style={styles.link} target="_blank" rel="noreferrer nofollow" href=""> </a>
            </p>
        </div>
    )
}
